import AlertCircle from '@crehana/icons/outline/AlertCircle';

import type { ErrorMessageDataProps } from './types';

const data: ErrorMessageDataProps = {
  icon: AlertCircle,
  title: 'ERROR_MESSAGE_TITLE',
  subtitle: 'ERROR_MESSAGE_SUBTITLE',
  tryAgainLabel: 'ERROR_MESSAGE_BUTTON',
};

export default data;
